__turbopack_context__.v({
  "appsColumn": "FolderZapTable-module__j8Hq5a__appsColumn",
  "lastModifiedColumn": "FolderZapTable-module__j8Hq5a__lastModifiedColumn",
  "lastRunColumn": "FolderZapTable-module__j8Hq5a__lastRunColumn",
  "statusColumn": "FolderZapTable-module__j8Hq5a__statusColumn",
});
